import jp from './transJP'
import en from './transEN'

const data = Object.assign(jp, en)

export { data }
